import { ExtraOptions } from '@angular/router';
import { IMfeProps } from '@charlesschwab/sac-ui-core';
import { ReplaySubject } from 'rxjs';

export const singleSpaPropsSubject = new ReplaySubject<IMfeProps>(1);
export const RouterConfig: ExtraOptions = { useHash: true };